import { Component } from "react";
import {getAllCountries} from '../../services/opportunityService';
import {Form, Button, Row, Col} from 'react-bootstrap';
import { USER_DATA, EXPERIENCE } from "../../helpers/constants";
import {INSTITUTE_CITY} from "../../helpers/dummies";
import {postUserProfessionalInformation, getUserProfessionalInformation, postUserProDocUpload} from '../../services/userInformation';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { WEBSITE_URL } from "../../services/baseService";
import UserProfileBanner from "./UserProfileBanner";
import { toast } from 'react-toastify';

class UserProfessionalInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            country_id:[],
            currentUser:[],
            success:'',
            year_of_experience:EXPERIENCE,
            city:INSTITUTE_CITY,
            cv:'',
            terms:false,
            userProfessionalInformation:{userPublicId:'', professional_objective:'', year_of_experience:'', started_date:new Date(), end_date:new Date(), is_in_progress:false, job_title:'', organization_name:'', website:'', city:'', country_id:'', your_task:'', cv:'', terms:false}
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.getUserProInformation = this.getUserProInformation.bind(this);
        this.getAllCountry = this.getAllCountry.bind(this);
        this.removeDocument = this.removeDocument.bind(this);
        this.uploadUserDocuments = this.uploadUserDocuments.bind(this);
    }

    componentDidMount() {
        try {
            let user = JSON.parse(localStorage.getItem(USER_DATA));            
            this.setState({currentUser:user})
            this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, userPublicId:user?.publicId}});
            this.getAllCountry();
            this.getUserProInformation(user?.publicId);
          
            setTimeout(()=>{
                this.setState({success:''});
            },500)
        }
        catch(error){console.log(error)}
    }

    getUserProInformation(userPublicId){
        getUserProfessionalInformation(userPublicId).then(res=>{
            console.log(res, 'this is the response dear')
            res != undefined ? this.setState({userProfessionalInformation:{...res, "publicId":userPublicId}}) :  this.setState({userProfessionalInformation:{userPublicId:userPublicId, professional_objective:'', year_of_experience:'', started_date:new Date(), end_date:new Date(), is_in_progress:false, job_title:'', organization_name:'', website:'', city:'', country_id:'', your_task:'', cv:'', terms:false}})
        }).catch(error=>console.log(error));
    }


    getAllCountry() {
        getAllCountries().then(response=>this.setState({country_id:response})).catch(error=>console.log(error, 'this is new error'));
    }

    onChange(e) {
        let {name, value, checked} = e.target;
        if(name == "is_in_progress") {
            console.log(checked, value, 'this is checked dear');
            checked == true ? this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, ['is_in_progress']:'yes'}}) : this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, ['is_in_progress']:'no'}})
        }
        if(name=='terms') {
            this.setState({terms:checked});
            // this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, [name]:checked}})
        }
        if(name=='cv') {
            this.setState({cv:e.target.files[0]?.name})
            this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, [name]:e.target.files[0]}})
        }
        else {
            this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, [name]:value}})
        }
    }
    

    uploadUserDocuments(e) {
        let formData = new FormData();
        formData.append('userPublicId', this.state.currentUser?.publicId);
        formData.append('cv', e.target.files[0])
        this.setState({cv:e.target.files[0]?.name})

        if(e.target.files[0]) {
            postUserProDocUpload(formData).then(response=>{
                if(response && response?.cv) {
                    this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, ['cv']:response?.cv}});
                    this.setState({success:''})
                }
                if(response && response?.message) {
                    this.setState({success:response?.message})
                    toast.error(`${response?.message}`);                    
                }
            }).catch(error=>console.log(error, 'this is the error'));
        }
    }

    onSubmit(e) {
        e.preventDefault();
        let formData = new FormData();
        let newData = {...this.state.userProfessionalInformation};    
        newData.started_date = moment(newData.started_date);
        newData.end_date = moment(newData.end_date);       

        formData.append('professional_objective', newData?.professional_objective);
        formData.append('userPublicId', newData?.userPublicId);
        formData.append('year_of_experience', newData?.year_of_experience);
        formData.append('started_date', newData?.started_date);
        formData.append('end_date', newData?.end_date);
        formData.append('is_in_progress', newData?.is_in_progress);
        formData.append('job_title', newData?.job_title);
        formData.append('organization_name', newData?.organization_name);
        formData.append('website', newData?.website);
        formData.append('city', newData?.city);
        formData.append('country_id', newData?.country_id);
        formData.append('your_task', newData?.your_task);
        formData.append('cv', newData?.cv);
       
        if(this.state.userProfessionalInformation?.cv==="") {
            if(this.state?.cv === "") {
                this.setState({success:'Please upload the document.'})
                toast.error('Please upload the document.');
            }
            else {
                postUserProfessionalInformation(formData).then(response=>{
                    if(response) {
                        this.setState({success:response?.message});
                        if(response?.message === "All fields required") {
                            toast.error(`${response?.message}`);
                        }
                        else {
                            toast.success("Professional Information Saved Successfully");
                            setTimeout(()=>{
                                this.props.history.push("/account");
                            },1000)
                        }
                    }
                    else{
                        toast.error("There is an error, kindly check.")
                    }
                    // this.setState({success:response?.message})
                }).catch(error=>console.log(error, 'this is new error'));
            }
        }
        else {
            postUserProfessionalInformation(formData).then(response=>{
                if(response) {
                    this.setState({success:response?.message})
                    toast.success("Professional Information Saved Successfully");
                    setTimeout(()=>{
                        this.props.history.push("/account");
                    },1000)
                }
                else{
                    toast.error("There is an error, kindly check.")
                }
                
            }).catch(error=>console.log(error, 'this is new error'));
        }
    }

    onDateChange(date, name) {
        this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, [name]:date}})
    }

    removeDocument() {
        this.setState({cv:''})
        this.setState({userProfessionalInformation:{...this.state.userProfessionalInformation, ['cv']:''}});
    }

    
    render() {        
        return(
            <>
                <UserProfileBanner />
                {/* {console.log(this.state.userProfessionalInformation, 'this is the state dear')} */}
                <div className="accordion content-accordion" id="UserBiographicInformations">
                    <div key='user_biographical_accordion' className="accordion-item">
                        <h2 className="accordion-header" id='heading'>
                            <button
                                className="accordion-button accordion-btn collapsed"
                                type="button" data-bs-toggle="collapse"
                                data-bs-target='#collapse'
                                aria-expanded="false" aria-controls='collapse'
                            >
                                Informations Professionnelle (Optional)
                            </button>
                        </h2>
                        <div
                            id='collapse'
                            className="accordion-collapse collapse show"
                            aria-labelledby='heading'
                            data-bs-parent="#UserBiographicInformations"
                        >
                            <div className="accordion-body">
                               
                                <Form onSubmit={this.onSubmit}>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="professional_objective">
                                                <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                    <strong>Mon objectif professionnel:</strong>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path d="M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 1C3.69 1 1 3.69 1 7C1 10.31 3.69 13 7 13C10.31 13 13 10.31 13 7C13 3.69 10.31 1 7 1Z" fill="#005073"/>
                                                            <path d="M7 3.5C5.89 3.5 5 4.39 5 5.5H6C6 4.95 6.45 4.5 7 4.5C7.55 4.5 8 4.95 8 5.5C8 6.5 6.5 6.38 6.5 8H7.5C7.5 6.88 9 6.75 9 5.5C9 4.39 8.11 3.5 7 3.5Z" fill="#005073"/>
                                                            <path d="M6.99988 10.62C7.3423 10.62 7.61988 10.3424 7.61988 10C7.61988 9.65759 7.3423 9.38 6.99988 9.38C6.65747 9.38 6.37988 9.65759 6.37988 10C6.37988 10.3424 6.65747 10.62 6.99988 10.62Z" fill="#005073"/>
                                                            <path d="M5.5 6C5.77614 6 6 5.77614 6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 5.77614 5.22386 6 5.5 6Z" fill="#005073"/>
                                                            <path d="M7 8.5C7.27614 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.27614 7.5 7 7.5C6.72386 7.5 6.5 7.72386 6.5 8C6.5 8.27614 6.72386 8.5 7 8.5Z" fill="#005073"/>
                                                        </svg>
                                                </Form.Label>
                                                <Form.Control as="textarea" name="professional_objective" onChange={this.onChange} value={this.state.userProfessionalInformation?.professional_objective} placeholder="example: Mon objectif professionnel est d’obtenir un poste de juriste d’entreprise dans le domaine du droit de l’énergie dans une compagnie multinationale" rows={4} style={{resize:'none'}} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12" md="4">
                                            <Form.Group controlId="year_of_experience">
                                                <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                    Année d'experience pertinente
                                                </Form.Label>
                                                {
                                                    this.state.year_of_experience && this.state.year_of_experience.length >0 && 
                                                    <Form.Control as="select" required custom onChange={this.onChange} name="year_of_experience" value={this.state.userProfessionalInformation?.year_of_experience}>
                                                        {this.state.year_of_experience?.map((experience)=>(<option key={experience?.id} value={experience?.id}>{experience?.year}</option>))}
                                                    </Form.Control>
                                                }                                                    
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                Vous pouvez rajoutez jusqu'à trois expériences professionnelles
                                            </Form.Label>
                                            <Row className="align-items-end">
                                                <Col>
                                                    <Form.Group  controlId="started_date">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Date de prise de fonction
                                                        </Form.Label>
                                                        {/* <DatePicker showIcon selected={this.state.userProfessionalInformation?.started_date ? moment(this.state.userProfessionalInformation?.started_date).toDate():this.state.userProfessionalInformation?.started_date} onChange={(date) => this.onDateChange(date, 'started_date')} name="started_date" />                                                */}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group controlId="end_date">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Date de fin de fonction
                                                        </Form.Label>
                                                        {/* <DatePicker showIcon selected={this.state.userProfessionalInformation?.end_date ? moment(this.state.userProfessionalInformation?.end_date).toDate():this.state.userProfessionalInformation?.end_date} onChange={(date) => this.onDateChange(date, 'end_date')} name="end_date" />                                                */}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group controlId="is_in_progress">
                                                        <Form.Check inline type='checkbox' checked={this.state.userProfessionalInformation?.is_in_progress == 'yes'?'checked':''} value={this.state.userProfessionalInformation?.is_in_progress=='yes'?'no':'yes'} name="is_in_progress" onChange={this.onChange} label="En cours" />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Form.Group  controlId="job_title">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Intitulé du poste
                                                        </Form.Label>
                                                        <Form.Control type="text" name="job_title" value={this.state.userProfessionalInformation?.job_title} onChange={this.onChange} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group  controlId="organization_name">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Nom de l’organisation
                                                        </Form.Label>
                                                        <Form.Control type="text" name="organization_name" value={this.state.userProfessionalInformation?.organization_name} onChange={this.onChange} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group  controlId="website">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Site Internet
                                                        </Form.Label>
                                                        <Form.Control type="url" name="website" value={this.state.userProfessionalInformation?.website} onChange={this.onChange} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Form.Group controlId="city">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Ville
                                                        </Form.Label>
                                                        {
                                                        this.state.city && this.state.city.length >0 && 
                                                        <Form.Control as="select" required custom onChange={this.onChange} name="city" value={this.state.userProfessionalInformation?.city}>
                                                            {this.state.city?.map((ville)=>(<option key={ville?.value} value={ville?.label}>{ville?.label}</option>))}
                                                        </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group controlId="country_id">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Pays
                                                        </Form.Label>
                                                        {
                                                        this.state.country_id && this.state.country_id.length >0 && 
                                                        <Form.Control as="select" required custom onChange={this.onChange} name="country_id" value={this.state.userProfessionalInformation?.country_id}>
                                                            {this.state.country_id?.map((country)=>(<option key={country?.id} value={country?.id}>{country?.name}</option>))}
                                                        </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group  controlId="your_task">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Tâches  
                                                        </Form.Label>
                                                        <Form.Control type="text" name="your_task" value={this.state.userProfessionalInformation?.your_task} onChange={this.onChange}/>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                
                                    <Row>
                                        <Col xs="12" sm="8">
                                            <Row className="m-0 mb-4 align-items-end">
                                                <Col xs="6" className="p-0">
                                                    <Form.Group className="position-relative file-group mb-0">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Télécharger CV
                                                        </Form.Label>
                                                        <Form.Control type="text" name="file_upload" defaultValue={this.state?.cv} id="file_upload"></Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col xs="12" md="6" className="p-0 ps-2 academic_attachment">
                                                    <Form.File id='cv' label="Upload" name="cv" onChange={(e)=>this.uploadUserDocuments(e)} />
                                                </Col>
                                                {
                                                    this.state?.userProfessionalInformation?.cv !="" && 
                                                    <Col xs="12" md="6" className="p-0 ps-2 academic_attachment mt-2">
                                                        <a target="_blank" href={WEBSITE_URL + '/' + this.state.userProfessionalInformation?.cv_path + '' + this.state.userProfessionalInformation?.cv} style={{fontSize:'12px'}}>
                                                            <i className='bx bx-download'></i> Download File
                                                        </a>
                                                        <i className='bx bx-trash' style={{color:"#ff0000", marginLeft:'5px'}} onClick={this.removeDocument}></i>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group  controlId="terms">
                                                <Form.Check inline type='checkbox' name="terms" value={this.state.terms} onChange={this.onChange} label="Acceptez tous les termes et conditions. Envoyez votre demande de vérification" />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {
                                    this.state?.terms ?
                                    <Row>
                                        <Col className="align-items-end d-flex justify-content-end">
                                            <Button className="btn-user-information" type="submit">Revoir</Button>
                                            <Button className="btn-user-information ml-3" type="submit">Soumettre</Button>
                                        </Col>
                                    </Row>:null
                                    }
                                </Form>
                                {
                                    this.state.success !== "" && (this.state.success==="Attachment allowed pdf,doc,docx" || this.state.success==="Please upload the document.") &&
                                    <div className={`${(this.state.success==="Attachment allowed pdf,doc,docx" || this.state.success==="Please upload the document.") && 'error-message'}`}>{this.state.success}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default UserProfessionalInformation;